<template>
  <div>
    <DocumentBreadcrumbs
      :parent-category="parentCategory"
      :permanent-category="permanentCategory"
      :navigate-function="navigateTo"
      :navigate-params="{
        ...queryParams,
        permanent_category_id: parentCategory ? parentCategory.id : null,
      }"
    />

    <div
      data-testid="move-list-move"
      class="sf-tab sf-tab-icons sf-below-3 sf-break-all"
    >
      <a
        v-if="permanentCategory"
        class="sf-a"
        @click="
          moveTo({ ...postParams, permanent_category_id: permanentCategory.id })
        "
      >
        <div class="sf-tab-item sf-block">
          <div class="sf-tab-item-icon">
            <span class="i-documents-forward" />
          </div>
          <div v-dompurify-html="moveToCategoryTranslation" />
        </div>
      </a>
      <a v-else class="sf-a" @click="moveTo(postParams)">
        <div class="sf-tab-item sf-block">
          <div class="sf-tab-item-icon">
            <span class="i-documents-forward" />
          </div>
          <div v-dompurify-html="moveToRootTranslation" />
        </div>
      </a>
    </div>
    <div v-if="permanentEntries.length > 0" class="sf-tab sf-tab-icons">
      <a
        v-for="entry in permanentEntries"
        :key="entry.id"
        class="sf-a"
        @click="navigateTo({ ...queryParams, permanent_category_id: entry.id })"
      >
        <div class="sf-tab-item sf-block">
          <div class="sf-tab-item-icon">
            <span
              class="
                i-documents-folder
                documents-document-icon
                sf-font-m sf-c-light
              "
            >
              <span
                v-if="entry.notVisibleForCustomers"
                class="
                  fa fa-eye-slash
                  documents-document-icon
                  documents-lock-icon
                  documents-eye-slash-icon-overlay
                  document-selector-eye-slash-icon-overlay
                "
              />
            </span>
          </div>
          <div>{{ entry.title }}</div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import DocumentBreadcrumbs from '@app/application/document/sections/document-breadcrumbs'

export default {
  components: { DocumentBreadcrumbs },
  props: [
    'title',
    'copy',
    'queryParams',
    'postParams',
    'permanentCategory',
    'permanentEntries',
  ],
  emits: ['navigate', 'move'],
  computed: {
    parentCategory() {
      return this.permanentCategory && this.permanentCategory.parentCategory
    },
    moveToRootTranslation() {
      if (this.copy) {
        return I18n.t('permanent.move_list.copy_to_root_html', {
          title: this.title,
        })
      }
      return I18n.t('permanent.move_list.move_to_root_html', {
        title: this.title,
      })
    },
    moveToCategoryTranslation() {
      if (this.copy) {
        return I18n.t('permanent.move_list.copy_to_category_html', {
          title: this.title,
          category: this.permanentCategory.title,
        })
      }
      return I18n.t('permanent.move_list.move_to_category_html', {
        title: this.title,
        category: this.permanentCategory.title,
      })
    },
  },
  methods: {
    navigateTo(params) {
      this.$emit('navigate', params)
    },
    moveTo(params) {
      this.$emit('move', params)
    },
  },
}
</script>
